<template>
  <div>
    <PageHeader title="จัดการหนังสือ"></PageHeader>
    <b-container>
      <b-row>
        <b-col>
          <div class="py-4">
            <div class="bg-container">
              <b-row class="align-items-end">
                <b-col cols="12" md="4">
                  <h6 class="mb-2 font-weight-bold">ชื่อหนังสือ</h6>
                  <search-box
                    title="ค้นหาหนังสือ"
                    @typed="getSearchKeyword"
                  ></search-box>
                </b-col>
                <b-col cols="12" md="3">
                  <h6 class="mb-2 font-weight-bold">จัดเรียงตาม</h6>
                  <b-form-select
                    v-model="selectedSortOption"
                    :options="sortOptions"
                    @change="onSortOptionChanged($event)"
                  ></b-form-select>
                </b-col>
                <b-col cols="12" md="5" class="text-right">
                  <b-button variant="primary" @click="goToCreateBook">
                    <b-icon-plus></b-icon-plus> สร้างหนังสือ
                  </b-button>
                </b-col>
              </b-row>

              <div v-if="!isLoading">
                <b-row class="mt-3">
                  <b-col
                    v-for="item in bookList?.data"
                    :key="item.book_id"
                    xl="2"
                    lg="3"
                    md="4"
                    sm="6"
                    class="py-3"
                  >
                    <BookCard
                      :book="item"
                      @edit="goToEditBook"
                      @delete="openDeleteModal"
                    />
                  </b-col>
                </b-row>

                <div
                  v-if="bookList?.data?.length === 0"
                  class="text-center text-muted py-5"
                >
                  <p>ไม่พบข้อมูลหนังสือ</p>
                </div>
              </div>

              <div v-else>
                <b-row class="mt-3">
                  <b-col
                    v-for="n in 6"
                    :key="n"
                    xl="2"
                    lg="3"
                    md="4"
                    sm="6"
                    class="py-3"
                  >
                    <b-card no-body class="h-100" style="height: 342px">
                      <b-skeleton-img
                        card-img="top"
                        aspect="3:4"
                      ></b-skeleton-img>
                      <b-card-body>
                        <b-skeleton width="40%"></b-skeleton>
                        <b-skeleton width="80%"></b-skeleton>
                      </b-card-body>
                    </b-card>
                  </b-col>
                </b-row>
              </div>

              <Pagination
                :items="bookList"
                :limits="[12, 24, 60]"
                @changePage="setFetchParamsPage"
                @changeLimit="setFetchParamsLimit"
                class="pagination pagination-csq pagination-sm rounded-0"
              />
            </div>
          </div>

          <DeleteBookModal
            :show="isShowDeleteModal"
            :book="selectedBook"
            @closed="isShowDeleteModal = false"
            @confirm="confirmDeleteBook"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import PageHeader from "../../layouts/PageHeader";
import SearchBox from "../../shared/SearchBox";
import Pagination from "../../shared/Pagination";
import BookCard from "./partials/BookCard";
import DeleteBookModal from "./partials/DeleteBookModal";
import api from "../../../services/api";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "BookListPage",
  components: {
    PageHeader,
    SearchBox,
    Pagination,
    BookCard,
    DeleteBookModal,
  },
  props: {
    company: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      selectedSortOption: { sort_by: "book_updatedAt", sort_order: "desc" },
      sortOptions: [
        {
          value: { sort_by: "book_updatedAt", sort_order: "desc" },
          text: "อัปเดตล่าสุด",
        },
        {
          value: { sort_by: "book_name", sort_order: "asc" },
          text: "ชื่อหนังสือ",
        },
      ],
      fetchParams: {
        company_id: null,
        page: 1,
        limit: 12,
        q: null,
        sort_by: "book_updatedAt",
        sort_order: "desc",
      },
      isShowDeleteModal: false,
      selectedBook: null,
    };
  },
  computed: {
    ...mapGetters("BookManagement", ["isLoading", "bookList"]),
  },
  async mounted() {
    if (this.company) {
      this.fetchParams.company_id = this.company.id;
    }
    await this.fetchBookList(this.fetchParams);
  },
  methods: {
    ...mapActions("BookManagement", ["fetchBookList", "deleteBook"]),
    getSearchKeyword(value) {
      this.fetchParams.q = value;
      this.fetchParams.page = 1;
      this.fetchBookList(this.fetchParams);
    },
    onSortOptionChanged(event) {
      this.fetchParams.sort_by = event.sort_by;
      this.fetchParams.sort_order = event.sort_order;
      this.fetchBookList(this.fetchParams);
    },
    setFetchParamsPage(page) {
      this.fetchParams.page = page;
      this.fetchBookList(this.fetchParams);
    },
    setFetchParamsLimit(limit) {
      this.fetchParams.limit = limit;
      this.fetchParams.page = 1;
      this.fetchBookList(this.fetchParams);
    },
    goToCreateBook() {
      this.$router.push({
        name: "book.management.create",
      });
    },
    goToEditBook(book) {
      this.$router.push({
        name: "book.management.edit",
        params: { bookId: book.book_id },
      });
    },
    async openDeleteModal(book) {
      this.selectedBook = book;
      await this.setBookCourses(book.book_id);
      this.isShowDeleteModal = true;
    },
    async confirmDeleteBook() {
      if (this.selectedBook) {
        try {
          await this.deleteBook(this.selectedBook.book_id);
          this.isShowDeleteModal = false;
          this.selectedBook = null;
          await this.fetchBookList(this.fetchParams);
          this.$bvToast.toast('ลบหนังสือสำเร็จ', {
            title: 'Success',
            variant: 'success',
            toaster: 'b-toaster-top-right',
            autoHideDelay: 2000,
            appendToast: true,
            noHoverPause: true,
            noCloseButton: true
          });
        } catch (error) {
          console.error('Delete book error:', error);
          this.$bvToast.toast('เกิดข้อผิดพลาดในการลบหนังสือ กรุณาลองใหม่อีกครั้ง', {
            title: 'Error',
            variant: 'danger',
            toaster: 'b-toaster-top-right',
            autoHideDelay: 3000,
            appendToast: true,
            noHoverPause: true,
            noCloseButton: true
          });
        }
      }
    },
    async setBookCourses(bookId) {
      try {
        const response = await api.get(`/v1/books/${bookId}/used-courses`);
        this.selectedBook.usedInCourses = response.data.data.map(course => course.c_name);
      } catch (error) {
        console.error('Failed to fetch book courses:', error);
        this.selectedBook.usedInCourses = [];
      }
    }
  },
};
</script>
